<template>
  <div v-if="ifLoad" style="width:100%;height:100%;" >
    <!-- 区域范围搜索 -->
    <div class="ol-map" :style="'width:'+useWidth+'px;height:'+ useHeight + 'px;'+(visitSource == 2?'float:left':'')" ref="olMap">
    </div>
    <div v-if="gisIfShowPie==1" :style="'width:350px;'+(visitSource == 2?'float:right;':'')+'border:1px solid;'+'height:'+ useHeight + 'px;background: #000;color: #fff;'">
      <ve-pie :data="globalChartData" :settings="pieChartSettings" :extend="pieChartOptions" :height="(useHeight/2)+'px'" :width="'100%'"></ve-pie>
      <el-row style="padding: 0 0 0 10px;"><el-col :span="8">名称</el-col><el-col :span="8">面积</el-col><el-col :span="8">面积占比</el-col></el-row>
      <template v-for="(chartDataOne,chartDataIndex) in globalChartData.rows">
        <el-row :key="'chartDataIndex_'+chartDataIndex" style="padding: 0 0 0 10px;" ><el-col :span="8">{{chartDataOne['名称']}}</el-col><el-col :span="8">{{chartDataOne['值']+'km²'}}</el-col><el-col :span="8">{{((chartDataOne['值']/globalChartData.totalNum)*100).toFixed(2)+'%'}}</el-col></el-row>
      </template>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Map from 'ol/Map'
import View from 'ol/View'
import { Draw } from 'ol/interaction'
import { Tile as TileLayer } from 'ol/layer'
import {XYZ, OSM} from 'ol/source'
import TileWMS from 'ol/source/TileWMS';
import { fromLonLat } from 'ol/proj'
//全屏 显示鼠标当前位置的经纬度 显示比例尺
import { defaults, FullScreen, MousePosition, ScaleLine } from 'ol/control'
import Feature from 'ol/Feature'
//点
import Point from 'ol/geom/Point'
//圆
import Circle from 'ol/geom/Circle'
//多面形
import Polygon from 'ol/geom/Polygon'
//线
import LineString from 'ol/geom/LineString'

import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import { Style, Icon,Stroke,Fill,Text } from 'ol/style'
//显示的元素结构
import Overlay from 'ol/Overlay'

//绘制组件
import kw_gis_draw from '@/components/form/kw_gis_draw.vue';

import { getWidth, getTopLeft } from 'ol/extent';
import WMTS from 'ol/tilegrid/WMTS';
import { WMTS as WMTSSource } from 'ol/source';
import { get as getProjection, getTransform } from 'ol/proj';
import { applyTransform } from 'ol/extent';

 import { register } from 'ol/proj/proj4';
import proj4 from 'proj4';
proj4.defs("EPSG:4490", "GEOGCS[\"China Geodetic Coordinate System 2000\",DATUM[\"China_2000\",SPHEROID[\"CGCS2000\",6378137,298.257222101,AUTHORITY[\"EPSG\",\"1024\"]],AUTHORITY[\"EPSG\",\"1043\"]],PRIMEM[\"Greenwich\",0,AUTHORITY[\"EPSG\",\"8901\"]],UNIT[\"degree\",0.0174532925199433,AUTHORITY[\"EPSG\",\"9122\"]],AUTHORITY[\"EPSG\",\"4490\"]]");
register(proj4);

// import OLCesium from 'ol-cesium';

import VCharts from 'v-charts'
Vue.use(VCharts);

import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'kw_gis_show',
  props: {
    //地图图形主键数组
    // value: {
    //   type: Array,
    //   default: function(){return[]}
		// },
    value: {
      type: Object,
       default: function(){
        return {};
      }
    },			
    pageSetInfo:{
      type: Object,
      default: function(){
        return {};
      }
    },			
    dataInfo:{
      type: Object,
      default: function(){
        return {};
      }
    },
    //可绘制的图形个数
    maxNum:{
      type:Number,
      default:1
    },
    //编辑状态  1:编辑  2:查看
    editType:{
      type:Number,
      default:1
    },
    nowCenter:{
      type:Object,
      default: function(){
        return{lng: 116.404, lat: 39.915}
      }
    },

    //圆半径 
    circleRadius:{
      type:Number,
      default:150
    },
    ifRefresh:{
      type:Boolean,
      default:true
    }
  },
  data() {
    let that = this;
    return {
      // 访问来源 PC:2 或者 H5:3
      visitSource:utils.checkVisitSource(that),
      ifLoad:false,
      gisDrawIfLoad:false,
      useWidth:500,
      useHeight:500,
      tk:"b1acdd87b938f6395b3f61d473f140ac",
      //是否显示统计饼图
      gisIfShowPie:1,
      map:null,
      mapCenter:[106.26667, 38.46667],
      initSource:null,
      //需要加载的geoServer图层信息
      geoserverLayerArr:[],
      //需要加载的坐标点集合图层信息
      pointLayer:null,
      /**
       * 弹出层组件的信息
       */
      dialogInfo:{
        ifLoad:false
      },
      //地图图形对应的数据数组
      valueInfo:[],
      pieChartSettings:{
        dimension:"名称",
        metrics:"值"
      },
      pieChartOptions:{
        title:{
          text:"",
          show:true,
          left: '10px',
          top: 'middle',
          right: 'auto',
          buttom: 'auto',
          textStyle:{
            fontSize:"14px",
            color:'#fff'
          },
        },
        legend:{
          show:true,
          type: 'scroll',
          orient: 'horizontal',
          // left: 'auto',
          // top: '10px',
          // right: 'auto',
          buttom: '0px',
          // itemWidth:15,
          // itemHeight:7,
          textStyle:{
              fontSize:12,
              color:'#fff'
          }
        },
        series:{
          type:'pie',
          radius: [0, '50%'],
          center: ['50%','50%'],
          label:{
              show: true,
              position:'outside',
              formatter:'{b}:{c}km²'
          }
        }
      },
      globalChartData:[],
      pointLayerStyle:new Style({
        image: new Icon({
          scale: 0.5, //大小
          src: require('./../look/img/site.png'), //图片
          // color: "#409EFF", //颜色
        }),
      }),
      pointLayerStyleImage:new Icon({
        scale: 0.5, //大小
        src: require('./../look/img/site.png'), //图片
        // color: "#409EFF", //颜色
      })
    };
  },
  created() {
    var that = this;
    if(this.value.styleSet) {
      if(this.value.styleSet.gisIfShowPie) {
        this.gisIfShowPie = this.value.styleSet.gisIfShowPie;
      }
    }
    if(that.visitSource == 2) {
      that.useWidth = window.innerWidth-80;
      if(that.gisIfShowPie == 1) {
        that.useWidth = that.useWidth - 350;
      }
      that.useHeight = window.innerHeight-200;
    } else {
      that.useWidth = window.innerWidth;
      that.useHeight = window.innerHeight-200;
    }
    that.ifLoad = true;
  },
  mounted() {
    this.initMap();
  },
  beforeDestroy(){
    
  },
  destroyed(){

  },
  watch:{
    ifRefresh:function(newVal){
      console.log("ifRefresh=========================================",this.pageSetInfo);
      this.loadGeoserverMap();
    }
  },
  computed:{
  },
  components: {
    kw_gis_draw
  },
  methods: {
    initMap:function(){
      var that = this;
    
      const tileLayer = new TileLayer({
          source: new XYZ({
            // url:"http://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk="+that.tk
            // url:"http://t4.tianditu.com/DataServer?T=cva_w&x={x}&y={y}&l={z}&tk=" +that.tk
            // url:"http://t0.tianditu.gov.cn/vec_c/wmts?tk=" +that.tk
              // url: 'https://webrd01.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}'
            // url:"http://t0.tianditu.com/DataServer?T=img_w&x={x}&y={y}&l={z}&tk=" + that.tk
            //普通天地图
            url: 'http://t3.tianditu.com/DataServer?T=vec_w&x={x}&y={y}&l={z}&tk='+that.tk,
            //// 卫星影像图层
            // url: 'http://t3.tianditu.com/DataServer?T=img_w&x={x}&y={y}&l={z}&tk='+that.tk,
            // url:"http://t0.tianditu.gov.cn/vec_c/wmts?tk=" + that.tk
          })
      })
      const bzLayer = new TileLayer({
          name:'注记',
          source: new XYZ({
            // crossOrigin:'anonymous',
            // url:'http://t0.tianditu.gov.cn/DataServer?T=cia_w&x={x}&y={y}&l={z}&tk=' + that.tk
            // url:'http://t0.tianditu.gov.cn/cva_c/wmts?tk=' + that.tk
            url:'http://t3.tianditu.com/DataServer?T=cia_w&x={x}&y={y}&l={z}&tk=' + that.tk
          })
        })
      let map = new Map({
          layers: [],
          view: new View({
              center: fromLonLat([106.26667, 38.46667]),//地图中心点
              zoom: 15,// 缩放级别
              minZoom: 0,// 最小缩放级别
              maxZoom: 18,// 最大缩放级别
              constrainResolution: true// 因为存在非整数的缩放级别，所以设置该参数为true来让每次缩放结束后自动缩放到距离最近的一个整数级别，这个必须要设置，当缩放在非整数级别时地图会糊
          }),
          target: this.$refs.olMap,// DOM容器
          controls: defaults().extend([
              new FullScreen(), // 全屏
              // new MousePosition(), // 显示鼠标当前位置的经纬度
              // new ScaleLine()// 显示比例尺
          ])
      })
      var tdt = that.getTianditu({
              type: '影像底图',
              // proj: '球面墨卡托投影',
              proj: '经纬度投影',
              key: that.tk
      });
      var zz = that.getTianditu({
              type: '影像注记',
              proj: '球面墨卡托投影',
              // proj: '经纬度投影',
      
              key: that.tk
      })
      map.addLayer(tdt);
      // map.addLayer(tileLayer);
      // map.addLayer(bzLayer);

      // var geocoder = new Geocoder('nominatim', {
      //   // provider: 'mapquest',
      //   // key: '__some_key__',
      //   lang: 'en-US', //en-US, fr-FR
      //   placeholder: 'Search for ...',
      //   targetType: 'text-input',
      //   limit: 5,
      //   keepOpen: true
      // });
      // map.addControl(geocoder);

      map.on('click', evt => {
        //判断鼠标是否悬停在要素上
        // let pixel = map.getEventPixel(evt.originalEvent);
        // let feature = this.map.forEachFeatureAtPixel(pixel, (feature) => { return feature;}, {hitTolerance:10});
        let pixel = evt.pixel;
        let feature = map.forEachFeatureAtPixel(pixel,function (feature) {
          return feature;
        });
        if (feature) {
          console.log("feature==============================",feature.getId()); //do something
          var featureId = feature.getId();
          var index = featureId.substring(featureId.indexOf("_")+1);
          var tabPageSet = that.pageSetInfo.tabPageSet;
          if(tabPageSet.length >= 2) {
            var tabOne = tabPageSet[1];
            if(tabOne.pageDataInfo) {
              var dataInfo = tabOne.pageDataInfo[0];
              var nowKwLook = that.getNowKwLook();           
              console.log("nowKwLook==========================",nowKwLook);
              var kwListDefault = nowKwLook.$refs.kw_list_1[0].$refs.kw_list_default;  
              pageUtils.dataButtonClick(kwListDefault,kwListDefault.pageSetInfo.operaButtonSet[0],dataInfo);  
            }
          }
        } else {
          console.log("false=============================="); //do something
        }
      })

      that.map = map;
      // map.on('click', e => {
      //     const coordinate = e.coordinate // 获取坐标
      //     console.log("coordinate================",coordinate);
      //     that.addPoint(coordinate);
      // })
    
      // that.loadGeoserverMap();
      // that.addMarket();
      // const ol3d = new OLCesium({map: map}); // ol2dMap is the ol.Map instance
      // ol3d.setEnabled(true);
    },
    getTianditu:function (options) {
            let layers = {
                    '全球境界': 'ibo',
                    '地形注记': 'cta',
                    '地形晕渲': 'ter',
                    '影像注记': 'cia',
                    '影像底图': 'img',
                    '矢量注记': 'cva',
                    '矢量底图': 'vec'
            }
            let projs = {
                    '经纬度投影': 'EPSG:4490',
                    '球面墨卡托投影': 'EPSG:900913'
            }
            let matrixSets = {
                    '经纬度投影': 'c',
                    '球面墨卡托投影': 'w'
            }
            let projection = getProjection(projs[options.proj]);
            let projectionExtent = projection.getExtent();
            let origin = projectionExtent ? getTopLeft(projectionExtent) : [-180, 90];
            let fromLonLat = getTransform('EPSG:4326', projection);
            let width = projectionExtent ? getWidth(projectionExtent) : getWidth(applyTransform([-180.0, -90.0, 180.0, 90.0], fromLonLat));
            let resolutions = [];
            let matrixIds = [];
            for (let z = 1; z < 19; z++) {
                    resolutions[z] = width / (256 * Math.pow(2, z));
                    matrixIds[z] = z;
            };
            let wmtsTileGrid = new WMTS({
                    origin: origin,
                    resolutions: resolutions,
                    matrixIds: matrixIds
            });
            let wmtsSource = new WMTSSource({
                    url: "http://t0.tianditu.gov.cn/" + layers[options.type] + "_" + matrixSets[options.proj] + "/wmts?tk=" + options.key,
                    layer: layers[options.type],
                    version: '1.0.0',
                    matrixSet: matrixSets[options.proj],
                    format: 'tiles',
                    projection: projection,
                    requestEncoding: 'KVP',
                    style: 'default',
                    tileGrid: wmtsTileGrid
            });
            let wmtsLayer = new TileLayer({
                    source: wmtsSource
            });
            return wmtsLayer
    },
    /** 加载发布在geoserver上面的地图 */
    loadGeoserverMap:function() {
      var that = this;
      var baseUrl = "http://121.40.81.205:9018/geoserver/yinchuan/wms";
      var defaultStyle = new Style({
          //边框样式
          stroke: new Stroke({
              color: 'white',
              width: 2,
          }),
          //填充样式
          fill: new Fill({
              color: 'rgba(255, 255, 255, 0.7)',
          }),
          // image: new Circle({
          //     radius: 5,
          //     fill: new ol.style.Fill({
          //         color: 'white',
          //     })
          // })
      });
      var baseLAYERS = "yinchuan:";
      var pageSetInfo = this.pageSetInfo;
      var tabPageSet = pageSetInfo.tabPageSet;
      that.geoserverLayerArr.forEach(function(layerOneInfo,layerOneIndex) {
        that.map.removeLayer(layerOneInfo);
      });
      that.geoserverLayerArr = [];
      if(tabPageSet){
        var mapCenter = [];
        //第一个选项卡为geoServer 图层
        if(tabPageSet.length >= 1) {
          var featuresArr = [];
          var chartDataRowsMap = {};
          tabPageSet.forEach((tabOne,tabIndex) => {
            if(tabOne.pageDataInfo) {
              tabOne.pageDataInfo.forEach(function(layerOneInfo,layerOneIndex) {
                if(mapCenter.length == 0 && layerOneInfo.LNG && layerOneInfo.LAT) {
                  mapCenter = [layerOneInfo.LNG,layerOneInfo.LAT];
                }
                var featureOne = new Feature();
                if(!layerOneInfo.MAP_TYPE || layerOneInfo.MAP_TYPE == 0) {
                  const geoserverLayer = new TileLayer({
                      source: new TileWMS({
                          url: baseUrl, // 请求地址
                          params: { // 请求的参数设置，其余参数可以不设置，使用默认的参数
                              LAYERS: baseLAYERS + layerOneInfo.LAYERS, // 请求的图层名
                              VERSION: '1.1.0', // wms请求的版本，也可用1.3.0
                              STYLES:'yinchuan',
                              SRS:'EPSG:3857'
                              // projection:getProjection('EPSG:3857')
                          }
                      }),
                  });
                  that.map.addLayer(geoserverLayer); // 加载图层到地图上
                  that.geoserverLayerArr.push(geoserverLayer);
                  var layerOneType = layerOneInfo.YZ_NAME;
                  if(!chartDataRowsMap[layerOneType]) {
                    chartDataRowsMap[layerOneType] = 0;
                  }
                  chartDataRowsMap[layerOneType] = chartDataRowsMap[layerOneType]+layerOneInfo.AREA*1
                } else if(layerOneInfo.MAP_TYPE == 1) {
                  featureOne.setId('pointIndex_'+layerOneIndex);
                  var pointOne = new Point([layerOneInfo.LNG,layerOneInfo.LAT]);
                  featureOne.setGeometry(pointOne);
                  that.addFeatureStyle(featureOne,'point_1',layerOneInfo);
                } else if(layerOneInfo.MAP_TYPE == 4) {
                  featureOne.setId('areaIndex_'+layerOneIndex);
                  if(layerOneInfo.CONTENT) {
                    var polygonOne = new Polygon([],null,null);
                    console.log("layerOneInfo.CONTENT----------------------------------",layerOneInfo.CONTENT);
                    polygonOne.setCoordinates([JSON.parse('['+layerOneInfo.CONTENT+']')]);
                    featureOne.setGeometry(polygonOne);
                    that.addFeatureStyle(featureOne,'polygon_1',layerOneInfo);
                  } else if(layerOneInfo.CONTENT_1) {
                    var polygonOne = new Polygon([],null,null);
                    console.log("layerOneInfo.CONTENT----------------------------------",layerOneInfo.CONTENT_1);
                    polygonOne.setCoordinates([JSON.parse('['+layerOneInfo.CONTENT_1+']')]);
                    featureOne.setGeometry(polygonOne);
                    that.addFeatureStyle(featureOne,'polygon_2',layerOneInfo);
                  }
                }
                featuresArr.push(featureOne);
              });
              console.log("globalChartData=======================",globalChartData);
            }
          });
          var chartDataRows = [];
          var totalNum = 0;
          for (const tmpkey in chartDataRowsMap){
            chartDataRows.push({
              "名称":tmpkey,
              "值":chartDataRowsMap[tmpkey]
            })
            totalNum += chartDataRowsMap[tmpkey]*1;
          }
          if(chartDataRows.length > 0) {
            var globalChartData = {
              columns:['名称','值'],
              rows:chartDataRows,
              totalNum:totalNum
            };
            that.globalChartData = globalChartData;
          }
          if(that.pointLayer) {
            that.map.removeLayer(that.pointLayer);
          }
          if(featuresArr.length > 0) {
            var initSource = new VectorSource();
            initSource.addFeatures(featuresArr);
            that.pointLayer = new VectorLayer({
              title: "草图图层", // ol-ext图层控件属性
              noSwitcherDelete: true, // ol-ext图层控件属性
              source: initSource, 
            });
            that.map.addLayer(that.pointLayer);
          }
        }
        if(mapCenter.length > 0) {
          that.mapCenter = mapCenter;
          that.setMapCenter();
        }
      }

    },
    addFeatureStyle:function(featureOne,type,layerOneInfo){
      var that = this;
      var markerStyle = null
      if(type == "point_1") {
        markerStyle = new Style({
          image: that.pointLayerStyleImage,
          text: new Text({
            scale: 2,  //字的大小
            text: "指标值:"+layerOneInfo.NOW_DATA, //这个储存的是后台传的值 例如温度等一些值。。
            offsetY:-20,
            fill: new Fill({
              color: (layerOneInfo.NOW_COLOR?layerOneInfo.NOW_COLOR:"white"),
            }),
          }),
        });
      } else if(type == "polygon_1") {
        markerStyle = new Style({
          stroke: new Stroke({       // 线样式
            color: 'green',
            width: 3
          }),
          fill: new Fill({           // 填充样式
              color: 'rgba(0, 0, 255, 0.1)'
          }),
          text: new Text({
            scale: 2,  //字的大小
            text: layerOneInfo.NAME, //这个储存的是后台传的值 例如温度等一些值。。
            offsetY:-20,
            fill: new Fill({
              color: (layerOneInfo.NOW_COLOR?layerOneInfo.NOW_COLOR:"white"),
            }),
          }),
        });
      } else if(type == "polygon_2"){
        markerStyle = new Style({
          stroke: new Stroke({       // 线样式
            color: 'red',
            width: 3
          }),
          fill: new Fill({           // 填充样式
              color: 'rgba(0, 0, 255, 0.1)'
          }),
          text: new Text({
            scale: 2,  //字的大小
            text: "任务名称", //这个储存的是后台传的值 例如温度等一些值。。
            offsetY:-20,
            fill: new Fill({
              color: (layerOneInfo.NOW_COLOR?layerOneInfo.NOW_COLOR:"white"),
            }),
          }),
        });
      }
      featureOne.setStyle(markerStyle);
    },
    setMapCenter:function(){
      var view = this.map.getView();
      // view.animate({center:this.mapCenter,duration:5});
      view.setCenter(this.mapCenter);
      // view.setCenter([11823894.237915877, 4652183.215704089]);
    },
    getNowKwLook:function(){
      var parentKwList = null;
      this.$emit("getNowKwLook",val => {
        parentKwList = val
      });
      return parentKwList;
    },
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.noSelectedDrawType{
  box-shadow: rgb(0 0 0 / 35%) 2px 2px 3px;
   background: rgb(255, 255, 255);
   color: #000
}
.selectedDrawType{
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    cursor: pointer;
    text-size-adjust: none;
    background: rgb(142, 168, 224);
    box-shadow: rgba(0, 0, 0, 0.35) 2px 2px 3px;  
    color: #fff  
}
.tabDrawType{
    border-width: 1px;
    border-style: solid;
    border-color: rgb(139, 164, 220);   
    padding: 10px 10px;
    font: bold 12px / 1.3em arial, sans-serif;
    text-align: center;
    white-space: nowrap;
    border-radius: 0px 3px 3px 0px;
}
.search-box {
  position: absolute;
  top: 25px;
  left: 20px;
}

</style>
<style>
.ol-map .ol-overlaycontainer-stopevent{
    width: unset !important;
    height: unset !important;;
    right: 20px !important;;
}
</style>